import { useQuery } from '@apollo/client';
import { useMemo } from 'react';

import {
  BulkSlotItemDataFragment,
  GetBulkSlotsDocument,
  GetBulkSlotsQueryVariables,
} from '../../types/api/graphql';

const useBulkSlotItems = (variables: GetBulkSlotsQueryVariables) => {
  const { data: bulkSlotsItemsData, loading: bulkSlotItemsDataLoading } =
    useQuery(GetBulkSlotsDocument, {
      variables: {
        ...variables,
      },
      skip: !variables.id,
    });
  const data = useMemo(() => {
    const items = (bulkSlotsItemsData?.bulkCampaignSlots?.items ??
      []) as BulkSlotItemDataFragment[];

    return [...items].sort((a, b) => {
      const dateA = new Date(a.appointment.startTime);
      const dateB = new Date(b.appointment.startTime);
      return dateB.getTime() - dateA.getTime();
    });
  }, [bulkSlotsItemsData?.bulkCampaignSlots]);

  return {
    data,
    loading: bulkSlotItemsDataLoading,
  };
};

export { useBulkSlotItems };
